import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import GenerateCaptionImage from "../../../assets/ImageSearch/images/api-generate-caption.png";
import TextualSearchImage from "../../../assets/ImageSearch/images/api-textual-search.png";
import VisualSearchImage from "../../../assets/ImageSearch/images/api-visual-search.png";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";

const ImageSearchAPI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageSearch.api" });
	const openDocs = (link: string) => window.open(link, "_blank");

	const imageSearchApiCards: ConsoleAPICardProps[] = [
		{
			image: GenerateCaptionImage,
			header: t("cards.generateCaption.header"),
			description: t("cards.generateCaption.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_SEARCH.GET_CAPTION.DOCS)}
				>
					{t("cards.generateCaption.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_SEARCH.GET_CAPTION.DOCS),
		},
		{
			image: TextualSearchImage,
			header: t("cards.textualSearch.header"),
			description: t("cards.textualSearch.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_SEARCH.SEARCH_BY_TEXT.DOCS)}
				>
					{t("cards.textualSearch.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_SEARCH.SEARCH_BY_TEXT.DOCS),
		},
		{
			image: VisualSearchImage,
			header: t("cards.visualSearch.header"),
			description: t("cards.visualSearch.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_SEARCH.SEARCH_BY_IMAGE.DOCS)}
				>
					{t("cards.visualSearch.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_SEARCH.SEARCH_BY_IMAGE.DOCS),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")}>
			<ConsoleAPICards cards={imageSearchApiCards} />
		</ConsoleAPILayout>
	);
};

export default observer(ImageSearchAPI);
